import ClipboardJS from 'clipboard';

import {autobind} from 'core-decorators';

import {Component} from 'inferno';

import {Link} from './Link';
import {Tooltip} from './Tooltip';


type ActivateTooltip = (...args: any[]) => void;


export class ShareIcon extends Component<jsx.Props, jsx.State> {
    imgElement: HTMLImageElement|null;
    activateTooltip?: ActivateTooltip;
    clipboard?: ClipboardJS;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.imgElement = null;
    }

    @autobind
    handleClick(event: Event) {
        if (this.props.onClick) {
            this.props.onClick(event, this);
        }
        window.gaEvent({
            category: 'ShareIcon',
            action: 'click',
            label: this.props.service,
        });
    }

    @autobind
    setImgElement(element: HTMLImageElement|null) {
        this.imgElement = element;
    }

    componentDidMount() {
        if (this.props.copyText && this.imgElement) {
            this.clipboard = new ClipboardJS(this.imgElement);
            if (this.activateTooltip) {
                this.clipboard.on('success', this.activateTooltip);
            }
        }
    }
    componentWillUnmount() {
        this.clipboard?.destroy();
    }
    render() {
        const gettextSub = this.context.gtService.gettextSub;

        const {
            title,
            service,
            url,
            mediaUrl,
            tags,
            copyText,
            ...props
        } = this.props;
        delete (props as any).onClick;
        let name;
        const encodedTitle = encodeURIComponent(title || '');
        const encodedURL = encodeURIComponent(url);
        const encodedMediaUrl = encodeURIComponent(mediaUrl || '');
        let to;
        if (service === 'imessage') {
            name = 'iMessage';
            to = 'https://apps.apple.com/app/apple-store/id917932200?pt=39040802&ct=iMessageItemView&mt=8';
        } else if (service === 'facebook') {
            name = 'Facebook';
            to = `https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`;
        } else if (service === 'twitter') {
            name = 'Twitter';
            to = `https://twitter.com/share?url=${encodedURL}&via=gifkeyboard`;
            if (tags?.length) {
                to += `&hashtags=${tags.join(',')}`;
            }
        } else if (service === 'reddit') {
            name = 'Reddit';
            to = `https://www.reddit.com/submit?url=${encodedURL}&title=${encodedTitle}`;
        } else if (service === 'pinterest') {
            name = 'Pinterest';
            to = `https://pinterest.com/pin/create/bookmarklet/?media=${encodedMediaUrl}&url=${encodedURL}&is_video=false&description=${encodedTitle}`;
        } else if (service === 'tumblr') {
            name = 'Tumblr';
            to = `https://www.tumblr.com/share?v=3&u=${encodedURL}&t=${encodedTitle}`;
            if (tags?.length) {
                to += `&tags=${tags.join(',')}`;
            }
        } else if (service === 'link') {
            name = 'link';
        } else if (service === 'embed') {
            name = 'embed';
        }
        if (copyText) {
            return (
                <span
                    className="ShareIcon"
                    onClick={this.handleClick}
                    {...props}
                >
                    <Tooltip
                        msg={gettextSub('Copied to clipboard.')}
                        hoverMsg={
                            gettextSub('Copy {name} to clipboard.', {name})}
                        addTooltipActivationCallback={(
                            callback: ActivateTooltip) => {
                            this.activateTooltip = callback;
                        }}
                    />
                    <img
                        src={`/assets/img/icons/${service}.svg`}
                        alt={`${name} icon`}
                        ref={this.setImgElement}
                        data-clipboard-text={copyText}
                    />
                </span>
            );
        }
        return (
            <Link
                className="ShareIcon"
                to={to}
                onClick={this.handleClick}
                {...props}
            >
                <Tooltip
                    hoverMsg={gettextSub('Share to {name}.', {name})}
                />
                <img
                    src={`/assets/img/icons/${service}.svg`}
                    alt={gettextSub('{name} icon', {name})}
                />
            </Link>
        );
    }
}
